// TODO Ideas for improvements: add more prop methods like onScroll, onScrollBottom, onScrollTop, etc.

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  className: PropTypes.string,
  // "height" for `vertical` orientation, "width" for `horizontal`
  maxSize: PropTypes.string,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
};

const defaultProps = {
  orientation: 'vertical',
};

const ScrollableDiv = forwardRef(
  ({ children, className, maxSize, orientation }, ref) => {
    const classes = classNames({
      'scrollable-div': true,
      [className]: !!className,
      [`scrollable-div-${orientation}`]: true,
    });

    const style =
      orientation === 'vertical'
        ? { maxHeight: maxSize }
        : { maxWidth: maxSize };

    return (
      <div className={classes} style={style} ref={ref}>
        {children}
      </div>
    );
  },
);

ScrollableDiv.propTypes = propTypes;
ScrollableDiv.defaultProps = defaultProps;
ScrollableDiv.displayName = 'ScrollableDiv';

export default ScrollableDiv;
